import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusesSection } from '../components/BonusesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { FaqSection } from '../components/FaqSection';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function Landing() {
  return <main className="min-h-screen bg-transparent" data-id="element-210">
      <HeroSection data-id="element-211" />
      <ProblemSection data-id="element-212" />
      <SolutionSection data-id="element-213" />
      <FeaturesSection data-id="element-214" />
      <ModulesSection data-id="element-215" />
      <BonusesSection data-id="element-216" />
      <BenefitsSection data-id="element-217" />
      <PricingSection data-id="element-218" />
      <GuaranteeSection data-id="element-219" />
      <TestimonialsBottom data-id="element-220" />
      <FaqSection data-id="element-221" />
      <FinalPricingCTA data-id="element-222" />
      <Footer data-id="element-223" />
      <StickyCTA data-id="element-224" />
    </main>;
}